import { render, staticRenderFns } from "./BlockPhotos.vue?vue&type=template&id=bf4f6aee&"
import script from "./BlockPhotos.vue?vue&type=script&lang=js&"
export * from "./BlockPhotos.vue?vue&type=script&lang=js&"
import style0 from "./BlockPhotos.vue?vue&type=style&index=0&id=bf4f6aee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports